<template>
    <div style="
    position: relative;
    background: #fff;
    width: 430px;
    height: 328px;">
        <div class="title">
            <div class="title-in">
                <span>安全验证</span>
                <span style="font-size: 12px"><!--请用键盘左右键横向滑动验证码进行安全验证--></span>
            </div>
            <a href="#" title="关闭安全验证" @click="Click"> <i class="el-icon-close"></i> </a>
        </div>

        <div class="con">
            <slide-verify
                    :l="42"
                    :r="10"
                    :w="348"
                    :h="155"
                    :imgs="picArray"
                    :show="false"
                    slider-text="向右滑动完成验证"
                    ref="slideverify"
                    @success="onSuccess"
                    @fail="onFail"
                    @refresh="onRefresh"
            ></slide-verify>
        </div>
    </div>
</template>

<script>
    export default {

        name: "SliderVerify",
        data() {

            return {

                //在data中引入`assets`中的图片可以通过`require`的方式来引入
                picArray: [
                    require("@/assets/verify/1.jpg"),

                ],

            };
        },
        methods: {
            Click(){
                this.$emit("close");
            },
            onSuccess() {

                this.$refs.slideverify.reset();
                //往父级传递验证通过的函数
                this.$emit("success");

            },
            onReset() {

                //重置图片验证组件
                this.$refs.slideverify.reset();
            },
            onFail() {
            },
            onRefresh() {
            },
        },
    };
</script>
<style scoped>
    .title{
        display: flex;
        align-items: center;
        background: #f5f5f5;
        height: 50px;
        padding-right: 18px;
        padding-left: 32px;
    }

    .title span {
        flex: 1;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #393939;
        text-align: center;
    }

    .title-in{
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .con{
        padding: 30px 40px 0 40px;
    }
</style>
